import { apiV2RobotHlsConnectPost } from '@maxtropy/device-customer-apis-v2';

export const isRtspUrl = (url?: string) => !!url && /^rtsp:\/\//i.test(url);

export interface RtspHlsSession {
  url: string;
  streamId?: string;
}

const rtspHlsSessionCache = new Map<string, RtspHlsSession>();
const RTSP_LOG_PREFIX = '[RTSP]';

const withCurrentOrigin = (url?: string) => {
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return url;
  const normalizedPath = url.startsWith('/') ? url : `/${url}`;
  return `${window.location.origin}${normalizedPath}`;
};

export const clearRtspHlsSession = (sourceUrl?: string) => {
  if (!sourceUrl) return;
  rtspHlsSessionCache.delete(sourceUrl);
};

export const getRtspHlsSession = async (sourceUrl?: string, force = false): Promise<RtspHlsSession | null> => {
  console.info(`${RTSP_LOG_PREFIX} hls resolve start`, { sourceUrl });
  if (!sourceUrl) return null;
  if (!isRtspUrl(sourceUrl)) {
    console.warn(`${RTSP_LOG_PREFIX} hls source is not rtsp url`, { sourceUrl });
    return null;
  }

  if (force) {
    clearRtspHlsSession(sourceUrl);
  }

  const cached = rtspHlsSessionCache.get(sourceUrl);
  if (cached) {
    console.info(`${RTSP_LOG_PREFIX} hls cache hit`, { sourceUrl, session: cached });
    return cached;
  }

  try {
    console.info(`${RTSP_LOG_PREFIX} hls request connect`, { rtspUrl: sourceUrl });
    const res = (await apiV2RobotHlsConnectPost({ rtspUrl: sourceUrl })) as any;
    const url = withCurrentOrigin(res?.url ?? res?.data?.url ?? '');
    const streamId = res?.streamId ?? res?.data?.streamId;
    if (url) {
      const session: RtspHlsSession = { url, streamId };
      rtspHlsSessionCache.set(sourceUrl, session);
      console.info(`${RTSP_LOG_PREFIX} hls connect success`, { rtspUrl: sourceUrl, playerUrl: url, streamId });
      return session;
    }
    console.warn(`${RTSP_LOG_PREFIX} hls connect success but empty url`, { rtspUrl: sourceUrl, res });
    return null;
  } catch (error) {
    console.error(`${RTSP_LOG_PREFIX} hls connect failed`, { rtspUrl: sourceUrl, error });
    return null;
  }
};
